import ArrowLeftIcon from '@precis-digital/kurama/icons/ArrowLeftIcon';
import Button from '@precis-digital/kurama/Button';
import Divider from '@precis-digital/kurama/Divider';
import Grid from '@precis-digital/kurama/Grid';
import ShopIcon from '@precis-digital/kurama/icons/ShopIcon';
import Typography from '@precis-digital/kurama/Typography';
import { styled } from '@precis-digital/kurama/utils';
import alvieLogoFull from 'public/assets/images/alvie_logo_full.svg';
import manWithPhone from 'public/assets/images/man_w_phone.png';
import ThemedImage from 'shared/components/Themed/Image';
import { useEffect, type ReactElement } from 'react';
import logger from 'shared/logger';
import { formatPageMetaTitle } from '../../utils/stringFormatter';
import { useChangePath, useGoBack, useReload } from '../Router';
import { StyledGridButtonsContainer, StyledGridErrorCodeMessageContainer, StyledGridPageContainer, StyledGridRightSideContainer, StyledGridTextContainer, StyledGridTopSectionContainer } from './styles';
import { APP_ROUTES } from 'shared/routes';
import { logAndReportError } from 'shared/errorReporter';
import { InternalServerError } from 'shared/errors';
import Head from 'next/head';
const log = logger().child({
  namespace: 'error'
});
const ErrUnExpected = ({
  error = new InternalServerError(),
  hasDashboardFrame = true
}: {
  error: Error | null | undefined;
  hasDashboardFrame?: boolean;
}): ReactElement => {
  useEffect(() => {
    if (error != null) {
      log.error(error.message);
      logAndReportError(new InternalServerError({
        cause: error
      }));
    }
  }, [error]);
  const {
    changePath
  } = useChangePath();
  const reload = useReload();
  const goBack = useGoBack();
  const handleTakeMeBackClick = (): void => {
    goBack();
    reload();
  };
  const handleTakeMeHomeClick = (): void => {
    void changePath(APP_ROUTES.home.basePage);
  };
  const handleLogoClick = (): void => {
    void changePath(APP_ROUTES.home.basePage);
  };
  return <>
      <Head>
        <title>
          {formatPageMetaTitle({
          pageTitle: 'Unexpected Error'
        })}
        </title>
      </Head>
      <StyledGridPageContainer hasDashboardFrame={hasDashboardFrame}>
        <StyledGridTopSectionContainer hasDashboardFrame={hasDashboardFrame}>
          <StyledGridImageContainer>
            <ThemedImage src={manWithPhone} alt="Man with phone" priority style={{
            maxWidth: '100%',
            height: 'auto'
          }} />
          </StyledGridImageContainer>
          {!hasDashboardFrame && <StyledGridLogoContainer onClick={handleLogoClick}>
              <ThemedImage src={alvieLogoFull} alt="Alvie Logo Icon Blue" width={128} height={64} priority style={{
            maxWidth: '100%',
            height: 'auto'
          }} />
            </StyledGridLogoContainer>}
          <StyledGridRightSideContainer>
            <StyledGridTextContainer>
              <Typography variant="h2">Oops, the app is throwing a tantrum...</Typography>
              <Typography variant="body2">
                Something unexpected occurred and the page you're after isn't behaving. Just like you, we're surprised -
                but fear not, we're already on it!
              </Typography>
            </StyledGridTextContainer>
            <StyledGridButtonsContainer>
              <Button leftIcon={<ArrowLeftIcon />} variant="filled" onClick={handleTakeMeBackClick}>
                Take me back
              </Button>
              <Button leftIcon={<ShopIcon />} variant="tonal" onClick={handleTakeMeHomeClick}>
                Take me home
              </Button>
            </StyledGridButtonsContainer>
          </StyledGridRightSideContainer>
        </StyledGridTopSectionContainer>
        <Divider />
        <StyledGridErrorCodeMessageContainer>
          <Typography variant="h4">500</Typography>
          <Typography variant="body2">
            - That's just an error which means something broke that we hadn't predicted could happen.
          </Typography>
        </StyledGridErrorCodeMessageContainer>
      </StyledGridPageContainer>
    </>;
};
const StyledGridImageContainer = styled(Grid)(() => ({
  width: '40%',
  marginLeft: '160px',
  marginRight: '-100px'
}));
const StyledGridLogoContainer = styled(Grid)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  display: 'flex',
  gap: '26px',
  padding: '14px',
  ':hover': {
    cursor: 'pointer',
    backgroundColor: theme.tokens.background.main.pressed
  },
  borderRadius: '16px'
}));
export default ErrUnExpected;